import { render, staticRenderFns } from "./DepartList.vue?vue&type=template&id=93757a50&scoped=true&xmlns%3Abackground-color=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./DepartList.vue?vue&type=script&lang=js"
export * from "./DepartList.vue?vue&type=script&lang=js"
import style0 from "./DepartList.vue?vue&type=style&index=0&id=93757a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93757a50",
  null
  
)

export default component.exports